import { render, staticRenderFns } from "./table-normal.vue?vue&type=template&id=6053de52&scoped=true&"
import script from "./table-normal.vue?vue&type=script&lang=js&"
export * from "./table-normal.vue?vue&type=script&lang=js&"
import style0 from "./table-normal.vue?vue&type=style&index=0&id=6053de52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053de52",
  null
  
)

export default component.exports